(function() {

    'use strict';

    /**
     * @module Plugins
     *
     * This plugin exposes the embed API highly inspired by Vimeo.
     *
     * @namespace sv_embed_api
     */


    var plugin = function(vc, ui, pub) {
        this._vc = vc;
        this._ui = ui;
        this._pub = pub;

        this._vc.subscribe('time_updated seeked ended progress', undefined, this);
    };

    plugin.prototype = {

        _name: plugin._name = 'sv_embed_api',

        on: function(mt, t) {
            var o, d, p;
            switch (mt) {
                case 'time_updated':
                	d = this._vc.getDuration();
                	p = t/d;
                	o = {
                	  seconds: t,
                	  percent: p,
                	  duration: d
                	};
                	this._pub('playProgress', o);
                break;
                case 'seeked':
                	d = this._vc.getDuration();
                	p = t/d;
                	o = {
                	  seconds: t,
                	  percent: p,
                	  duration: d
                	};

                	this._pub('seek', o);
                break;
                case 'ended':
                	this._pub('finished');
                break;
                case 'progress':
                	var cache = this._vc.getCache(true);

                	if(!cache) {
                		return;
                	}
                	o = {
                		percent: cache.end,
                		duration: this._vc.getDuration(),
                		bytesLoaded: -1,
                		bytesTotal: -1
                	};

                this._pub('loadProgress', o);

                break;
            }
        }

    };

    SAPO.Project.Video.Controllers._plugins.push(plugin);

})(undefined);
